import { requestJson, requestVoid } from '../api/http';
import { type Owner, ownerSchema } from './owner';

export interface LoginCredentials {
  readonly email: string;
  readonly password: string;
}

/** `GET /me`: who this session belongs to. Rejects with `ApiError` (`401 not_authenticated`)
 * when there is no valid session - that `401` is how the app learns it is signed out. */
export function fetchMe(): Promise<Owner> {
  return requestJson('/me', ownerSchema);
}

/** `POST /auth/login`. Public: no session exists yet, so no CSRF header is needed or sent. */
export function login(credentials: LoginCredentials): Promise<Owner> {
  return requestJson('/auth/login', ownerSchema, { method: 'POST', body: credentials });
}

/** `POST /auth/logout`. Owner-only and CSRF-protected like any other state change. */
export function logout(): Promise<void> {
  return requestVoid('/auth/logout', { method: 'POST' });
}
